function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18 16.75a.75.75 0 01-.6-1.2 5.94 5.94 0 000-7.1.75.75 0 011.2-.9c1.96 2.62 1.96 6.28 0 8.9-.15.2-.37.3-.6.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.83 19.25a.75.75 0 01-.6-1.2c2.67-3.56 2.67-8.54 0-12.1a.75.75 0 011.2-.9c3.07 4.09 3.07 9.81 0 13.9-.14.2-.37.3-.6.3zM14.02 3.78c-1.12-.62-2.55-.46-4.01.45L7.09 6.06c-.2.12-.43.19-.66.19H5c-2.42 0-3.75 1.33-3.75 3.75v4c0 2.42 1.33 3.75 3.75 3.75h1.43c.23 0 .46.07.66.19l2.92 1.83c.88.55 1.74.82 2.54.82a3 3 0 001.47-.37c1.11-.62 1.73-1.91 1.73-3.63V7.41c0-1.72-.62-3.01-1.73-3.63z"
})));